export default __webpack_public_path__ + "static/media/litepaperBannerBg.1822d4a8.png";